/** @jsxImportSource @emotion/react */


import { useState } from 'react';



import { Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

export default function OccSkeletonImage({
  image,
  active = true,
  objectFit = 'cover',
}) {
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(true);

  return (
    <div css={styles.wrap}>
      {loading && (
        <Skeleton.Image
          active={active}
          style={{ width: '100%', height: '100%' }}
        />
      )}
      <img alt={t('imageAlt.photo')}
        src={image}
        style={{
          width: loading ? '0px' : '100%',
          height: loading ? '0px' : '100%',
          borderRadius: '4px',
          objectFit: objectFit,
        }}
        onLoad={() => {
          setLoading(false);
        }}
      />
    </div>
  );
}

const styles = {
  wrap: {
    borderRadius: '4px',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    height: '100%',
    '& .ant-skeleton-element': {
      width: '100%',
      height: '100%',
    },
  },
};
